import { generatePath } from 'react-router';
import request from '../api';
import { API_ROUTES } from '../consts';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';
import { buildOrder, buildRequestParamsByType, buildSelect } from '../utils/request';
import { formatTalentResponse } from './formatters';

export const getTalents = async (query: ApiQuery): Promise<TalentsListResponse> => {
  const { where } = query;
  const { data } = await request.get(API_ROUTES.TALENTS, {
    params: {
      ...buildRequestParamsByType(query.contains || {}, RequestQueryBuilderParamsEnum.contains),
      ...buildRequestParamsByType(query.in || {}, RequestQueryBuilderParamsEnum.in),
      ...where,
      order: buildOrder(query.order || {}),
      select: buildSelect(query.select),
      page: query.page,
      limit: query.limit,
    },
  });

  return data;
};

export const getTalent = async (talentId:string): Promise<FormattedTalentResponse> => {
  const { data } = await request.get(`${API_ROUTES.TALENTS}/${talentId}`);

  return formatTalentResponse(data);
};

// todo MATAN1: check / remove
export const getLatestTalentVersion = async (talentId:string): Promise<TalentResponse> => {
  const { data } = await request.get(`${API_ROUTES.TALENTS}/${talentId}`, {
    params: {
      select: 'version',
    },
  });

  return data;
};

export const getIcons = async (): Promise<Icon[]> => {
  const { data } = await request.get(`${API_ROUTES.ICONS}`);

  return data;
};

export const getLinkedInTalent = async (linkedInUrl:string): Promise<FormattedTalentResponse> => {
  const { data } = await request.get(API_ROUTES.TALENT_LINKEDIN, {
    params: {
      linkedinUrl: linkedInUrl,
    },
  });

  return formatTalentResponse(data);
};

export const getTalentHistory = async (
  talentId: string,
):Promise<HistoryLogResponse> => {
  const url = generatePath(API_ROUTES.HISTORY_TALENT, { talentId });

  const { data } = await request.get(url);

  return data;
};

export const postTalent = async (talentItem: TalentUpdate): Promise<TalentResponse> => {
  const { data } = await request.post(API_ROUTES.TALENTS, talentItem);

  return data;
};
export const uploadTalentImage = async (formData:FormData): Promise<{fileUrl: string}> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const { data } = await request.post(API_ROUTES.TALENTS_IMAGE_UPLOAD, formData, config);

  return data;
};

export const uploloadCompanyImage = async (formData:FormData): Promise<{fileUrl: string}> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const { data } = await request.post(API_ROUTES.COMPANY_IMAGE_UPLOAD, formData, config);

  return data;
};
export const uploadAcademicImage = async (formData:FormData): Promise<{fileUrl: string}> => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  };
  const { data } = await request.post(API_ROUTES.ACADEMIC_IMAGE_UPLOAD, formData, config);

  return data;
};

export const getCompaniesList = async (query: string):
Promise<CompaniesResponse> => {
  const { data } = await request.get(API_ROUTES.COMPANIES, {
    params: {
      name__contains: query,
    },
  });

  return data;
};
export const getAcademicList = async (query: string):
Promise<AcademicResponse> => {
  const { data } = await request.get(API_ROUTES.ACADEMIC_INSTITUTIONS, {
    params: {
      name__contains: query,
    },
  });

  return data;
};

export const getLinkedInCompaniesList = async (query: string):
Promise<CompaniesResponse> => {
  const { data } = await request.get(API_ROUTES.LINKEDIN_COMPANIES, {
    params: {
      linkedinUrl: query,
    },
  });

  return [{ ...data }];
};

export const getAcademicInstitutionByLinkedinUrl = async (linkedinUrl: string):
Promise<Academic> => {
  const { data } = await request.get(API_ROUTES.ACADEMIC_INSTITUTIONS_FROM_LINKEDIN_URL, {
    params: {
      linkedinUrl,
    },
  });

  return data;
};

export const updateContactDetails = async (
  contactDetails: ContactDetails,
  talentId: string): Promise<ContactDetails & {talentId:string}> => {
  const url = generatePath(API_ROUTES.CONTACT_DETAILS, { talentId });
  const { data } = await request.put(url, { ...contactDetails });

  return data;
};

export const createManualCompany = async ({ name, logo }: CreateManualCompanyRequest)
: Promise<Company> => {
  const { data } = await request.post(API_ROUTES.COMPANY_MANUAL, {
    name,
    logo: logo || undefined,
  });

  return data;
};

export const createManualEducation = async ({ name, logo }: CreateManualEducationRequest):
Promise<Academic> => {
  const { data } = await request.post(API_ROUTES.ACADEMIC_MANUAL, {
    name,
    logo: logo || undefined,
  });

  return data;
};

export const getMissingContactDetails = async (talentId: string):
  Promise<MissingContactDetails> => {
  const path = generatePath(API_ROUTES.CONTACT_DETAILS_LOOKUP, { talentId });
  const { data } = await request.get(path);

  return data;
};

export const requestMissingContactDetails = async (talentId: string):
  Promise<void> => {
  const path = generatePath(API_ROUTES.CONTACT_DETAILS_LOOKUP, { talentId });
  const { data } = await request.post(path);

  return data;
};
